/** @jsxImportSource @emotion/react */
import { TooltipWrapper } from 'components/atoms/TooltipWrapper'
import React from 'react'

/**
 * The outlined status pill used across the billing screens: ERA claim match
 * status, a forwarded remittance, and a charge's waterfall state. One
 * component so the same fact never reads as two different badges.
 */
export const StatePill: React.FC<{
  color: string
  label: string
  tooltip?: string
}> = ({ color, label, tooltip }) => (
  <TooltipWrapper text={tooltip || ''} show={!!tooltip}>
    <span
      css={{
        // Sized to its text: in a flex column a stretched pill would run the
        // width of the cell.
        display: 'inline-block',
        alignSelf: 'flex-start',
        padding: '1px 7px',
        borderRadius: 10,
        border: `1px solid ${color}`,
        color,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        cursor: tooltip ? 'help' : undefined,
      }}>
      {label}
    </span>
  </TooltipWrapper>
)
